export const defaultFeatureFlags = {
  facebook_login: false,
  google_login: false,
  google_pay: false,
  apple_pay: false
}

export type FeatureFlags = typeof defaultFeatureFlags

export const getFeatureFlags = (attributes: { uid: string; value: unknown }[]): FeatureFlags => {
  const flags = { ...defaultFeatureFlags }
  Object.keys(flags).forEach(key => {
    const value = attributes.find(attribute => attribute.uid === key)?.value
    flags[key] = value === true || (typeof value === 'string' && value.trim().toLowerCase() === 'true')
  })
  return flags
}

export const isPaymentMethodEnabled = (uid: string, flags: FeatureFlags, applePaySupported: boolean) => {
  if (uid === 'google_pay_bog') return flags.google_pay
  if (uid === 'apple_pay_bog') return flags.apple_pay && applePaySupported
  return true
}
